(function () {
    'use strict';

    angular
        .module('generalReports')
        .controller('TargetClientsController', TargetClientsController);

    TargetClientsController.$inject = ['$uibModalInstance', 'clients'];

    function TargetClientsController($uibModalInstance, clients) {
        var vm = this;

        vm.clients          = clients;
        vm.ok               = ok;
        vm.cancel           = cancel;

        function ok () {
            $uibModalInstance.close();
        }

        function cancel () {
            $uibModalInstance.close();
        }
    }

})();